import { L } from '../lib/abpUtility';
import { notification } from 'antd';
import axios from 'axios';

const qs = require('qs');

declare var abp: any;

//console.log(abp.appServiceUrl);
const http = axios.create({
  baseURL: abp.appServiceUrl,
  timeout: 1800000,
  paramsSerializer: function(params) {
    return qs.stringify(params, {
      encode: false,
    });
  }
});

http.interceptors.request.use(
  function(config) {
    if (!!abp.auth.getToken()) {
      config.headers.common['Authorization'] = `Bearer ${abp.auth.getToken()}`;
    }
    
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    let _response = error.response;
    if (typeof _response !== "undefined" && typeof _response.config !== "undefined" && typeof _response.config.url !== "undefined") {
      var arrPath = _response.config.url.split('/');
      if (arrPath.length > 0 && arrPath[arrPath.length - 1] === "checkToken") {
        localStorage.clear();
        sessionStorage.clear();
        abp.auth.clearToken();
        window.location.href = '/login';
      }
    }

    if (!!_response && !!_response.data.error && !!_response.data.error.message && _response.data.error.details) {
      localStorage.setItem("request-err", _response.data.error.details);
      notification.error({
        message: _response.data.error.message,
        description: _response.data.error.details,
        placement: 'bottomRight'
      });
    } else if (!!_response && !!_response.data.error && !!_response.data.error.message) {
      localStorage.setItem("request-err", _response.data.error.message);
      notification.error({
        message: L('Common.Error'),
        description: _response.data.error.message,
        placement: 'bottomRight'
      });
    } else if (!_response) {
      localStorage.setItem("request-err", L('Common.UnknownError'));
      notification.error({
        message: L('Common.Error'),
        description: L('Common.UnknownError'),
        placement: 'bottomRight'
      });
    }
    else if (!!_response && !!_response.data.message) {
      localStorage.setItem("request-err", _response.data.message);
      notification.error({
        message: L('Common.Error'),
        description: _response.data.message,
        placement: 'bottomRight'
      });
    }

    if (!!error.response && error.response.status === 401) {
      localStorage.setItem("request-err", error.response.data.message);
      notification.error({
        message: L('Common.Error'),
        description: error.response.data.message,
        placement: 'bottomRight'
      });
    }

    return false;
    //return Promise.reject(error);
  }
);

export default http;
